import {Title} from '@angular/platform-browser';
import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'page-title',
    template: '',
    standalone: false
})
export class PageTitleComponent implements OnInit {

	@Input() public value: string = "DEFAULT TITLE";

	constructor(
		private _title: Title,
	) {}

	ngOnInit(): void {
		this._title.setTitle(this.value);
	}
}
